var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignSpeed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6849 6.33628H8.56993L12.2702 0.312843C12.3468 0.1853 12.2777 0 12.1525 0H4.98918C4.93688 0 4.88645 0.0360973 4.8603 0.0962595L0.0205875 10.8653C-0.0373172 10.9928 0.0336626 11.1541 0.149472 11.1541H3.40708L1.73718 19.7597C1.70169 19.9474 1.87727 20.0797 1.98561 19.945L12.7876 6.66597C12.8848 6.54805 12.8194 6.33628 12.6849 6.33628ZM3.90954 15.3173L5.03588 9.51766H2.09582L5.63734 1.63882H9.83263L5.94181 7.9751H9.88306L3.90954 15.3173Z",
    fill: "#737981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignSpeed);
export default __webpack_public_path__ + "static/media/designSpeed.ef36e2e02bbfce81d6257e9f76b0573e.svg";
export { ForwardRef as ReactComponent };